import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function RemindersBar({ show }) {
  const [data, setData] = useState(null);
  const [openList, setOpenList] = useState(false);

  const load = useCallback(() => {
    axios.get(`${API}/reminders`).then((r) => setData(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, [load]);

  if (!data || data.count === 0) return null;
  const overdue = data.reminders.filter((r) => r.severity === "overdue").length;

  return (
    <div className={`rem-bar no-print ${overdue ? "has-overdue" : ""}`} data-testid="reminders-bar">
      <button className="rem-head" onClick={() => setOpenList(!openList)} data-testid="reminders-toggle">
        <span className="rem-count">{data.count}</span>
        <span className="rem-title">{overdue ? `${overdue} overdue · ` : ""}{data.count} reminder{data.count !== 1 ? "s" : ""} — email delivery status in the Email Center</span>
        <span className="rem-caret">{openList ? "▴" : "▾"}</span>
      </button>
      {openList && (
        <ul className="rem-list" data-testid="reminders-list">
          {data.reminders.map((r, i) => (
            <li key={i} className={`rem-item ${r.severity}`}>
              <button onClick={() => { show(r.target); setOpenList(false); }} data-testid={`reminder-item-${i}`}>
                <span className={`rem-dot ${r.severity}`} />{r.text}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
